import * as React from "react";
import { Collapse, Slider, Input } from "antd";
import styled from "styled-components";
import { ChromePicker } from "react-color";
import update from "immutability-helper";
import { ThemeContext } from "../../../../themeDesigner";

const Panel = Collapse.Panel;

const Label = styled.label`
  font-family: Muli;
  font-size: 13px;
  font-weight: 600;
  color: #7f90af;
  display: block;
  margin-bottom: 8px;
`;

const SettingRow = styled.div`
  margin-bottom: 16px;
`;

const ColorPickerWrapper = styled.div`
  margin-bottom: 8px;
`;

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;

  input {
    flex: 1;
  }
`;

export default function ScrollbarProperties() {
  const { themeProps, setThemeProps } = React.useContext(ThemeContext);
  const scrollbar = themeProps.widget.modernUIStyles.scrollbar;

  const handleUpdate = (key: string, value: any) => {
    const numValue = typeof value === "number" ? value : (Array.isArray(value) ? value[0] : value);
    const updated = update(themeProps, {
      widget: {
        modernUIStyles: {
          scrollbar: {
            [key]: { $set: numValue },
          },
        },
      },
    });
    setThemeProps(updated);
  };

  return (
    <Collapse defaultActiveKey={["1"]}>
      <Panel header="Scrollbar Styles" key="1">
        <SettingRow>
          <Label>Width (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={scrollbar.width}
              onChange={(e) => handleUpdate("width", parseInt(e.target.value) || 5)}
              min={2}
              max={20}
            />
            <span>{scrollbar.width}px</span>
          </Wrapper>
          <Slider
            value={scrollbar.width}
            onChange={(val) => handleUpdate("width", val)}
            min={2}
            max={20}
            step={1}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Border Radius (px)</Label>
          <Wrapper>
            <Input
              type="number"
              value={scrollbar.borderRadius}
              onChange={(e) =>
                handleUpdate("borderRadius", parseInt(e.target.value) || 5)
              }
              min={0}
              max={20}
            />
            <span>{scrollbar.borderRadius}px</span>
          </Wrapper>
          <Slider
            value={scrollbar.borderRadius}
            onChange={(val) => handleUpdate("borderRadius", val)}
            min={0}
            max={20}
            step={1}
            style={{ marginTop: "8px" }}
          />
        </SettingRow>

        <SettingRow>
          <Label>Color</Label>
          <ColorPickerWrapper>
            <ChromePicker
              color={{
                r: scrollbar.color.r,
                g: scrollbar.color.g,
                b: scrollbar.color.b,
                a: scrollbar.color.a,
              }}
              onChangeComplete={(color) => {
                handleUpdate("color", {
                  r: color.rgb.r,
                  g: color.rgb.g,
                  b: color.rgb.b,
                  a: color.rgb.a,
                });
              }}
            />
          </ColorPickerWrapper>
        </SettingRow>
      </Panel>
    </Collapse>
  );
}
